// Parsed HandleBars Template

const parsedTmpls = {};

$('.hbTemplate').each((index, elm) => {
  parsedTmpls[$(elm).attr('id')] = window.Handlebars.compile($(elm).html());
});

$('.hbPartial').each((index, elm) => {
  window.Handlebars.registerPartial($(elm).attr('id'), $(elm).html());
});

export default parsedTmpls;

export const parseHandleBars = templateString => {
  return window.Handlebars.compile(templateString);
};
